import { InibuildsA350Seo } from "../../../content/templateMarketing/inibuilds-a350-seo";
import { AircraftAddonTemplate } from "../../../lib/model/addonTemplate";
import a350Image from "../../images/templates/inibuilds-a350.png";

export const a350Template: AircraftAddonTemplate = {
  type: "aircraft",
  title: "iniBuilds A350",
  id: "inibuilds-a350",
  platforms: ["msfs"],
  image: a350Image,
  infoMarketingBlurb: InibuildsA350Seo,
  content: [
    {
      title: "Pre-Flight",
      roles: ["cockpitPreparation"],
      content: [
        { header: "Safety Check" },
        { item: "Parking Brake", setting: "On" },
        { item: "Landing Gear Lever", setting: "Down" },
        { item: "Thrust Levers", setting: "Idle" },
        { item: "Engine Master Levers", setting: "Off" },
        { item: "Engine Start Selector", setting: "Norm" },
        { item: "Speed Brakes", setting: "Retracted" },
        { item: "Flaps Lever", setting: "In Agreement" },
        { item: "Wipers", setting: "Off" },
        { header: "Power Up" },
        { item: "Batteries", setting: "On" },
        { item: "External Power", setting: "As Req / On" },
        { item: "Nav Light", setting: "1 or 2" },
        { item: "Interior Lights", setting: "As Req" },
        { item: "ADIRS", setting: "Nav" },
        { header: "Fire Test / APU Start" },
        { item: "APU Fire Test", setting: "Perform" },
        { item: "APU Master", setting: "On" },
        { item: "APU", setting: "Start" },
      ],
    },
    {
      title: "Cockpit Preparation",
      roles: ["cockpitPreparation"],
      content: [
        { header: "APU Power Switch Over" },
        { item: "APU", setting: "Check Avail" },
        { item: "APU Bleed", setting: "On" },
        { item: "External Power", setting: "Off" },
        { header: "Overhead Panel" },
        { item: "Oxygen Crew Supply", setting: "On" },
        { item: "ADIRS", setting: "Nav" },
        { item: "Strobe", setting: "Auto" },
        { item: "Beacon", setting: "Off" },
        { item: "Nav", setting: "1 or 2" },
        { item: "Logo", setting: "Auto" },
        { item: "Wing, LDG, Nose", setting: "Off" },
        { item: "Annunciator Lights", setting: "Test, then BRT or DIM" },
        { item: "Passenger Signs", setting: "As Desired / Auto" },
        { item: "Emergency Exit Lights", setting: "Arm" },
        { item: "APU Bleed", setting: "On" },
        { item: "Fuel Pumps", setting: "On" },
        { item: "Overhead Panel", setting: "No White" },
      ],
    },
    {
      title: "Cockpit Preparation (Contd)",
      roles: ["cockpitPreparation"],
      content: [
        { header: "Glare Shield Panel" },
        { item: "Altimeter", setting: "Set" },
        { item: "ND Modes", setting: "As Req / DES" },
        { item: "WX Radar", setting: "Off" },
        { item: "Flight Director", setting: "On" },
        { item: "SPD + HDG", setting: "Check Dashed" },
        { item: "ALT SEL", setting: "Set" },
        { header: "Main Panel & Pedestal" },
        { item: "PFD FMA", setting: "Check CLB | NAV" },
        { item: "ECAM Pages", setting: "Check As Desired" },
        { item: "Anti-Skid", setting: "On" },
        { item: "Landing Gear Lever", setting: "Down" },
        { item: "Standby Instruments", setting: "Check / Set" },
        { item: "Transponder / TCAS", setting: "Squawk Set / Stby" },
        { item: "Thrust Levers", setting: "Idle" },
        { item: "Radio Panel", setting: "Set" },
        { item: "Speed Brakes / Ground Spoilers", setting: "Retracted" },
        { item: "Flaps", setting: "In Agreement" },
        { item: "Rudder Trim", setting: "Neutral" },
        { item: "Oxygen Masks", setting: "Test" },
      ],
    },
    {
      title: "Before Start",
      roles: ["beforeFlightStart", "beforePushback", "beforeEngineStart"],
      content: [
        { item: "Loadsheet - Fuel / Payload", setting: "Check" },
        { item: "ECAM - Fuel Quantity", setting: "Check" },
        { item: "Takeoff Data", setting: "Check" },
        { item: "ADIRS", setting: "Aligned" },
        { item: "APU", setting: "On" },
        { item: "APU Bleed", setting: "On" },
        { item: "External Power", setting: "Disconnected" },
        { item: "Doors", setting: "Closed / Armed" },
        { item: "MFD Checklist", setting: "Before Start - To the Line" },
        { header: "When Ready to Push" },
        { item: "Cockpit Door", setting: "Locked" },
        { item: "Passenger Signs", setting: "On" },
        { item: "Beacon", setting: "On" },
        { item: "Transponder", setting: "Auto" },
        { item: "Accu Pressure", setting: "Green" },
        { item: "MFD Checklist", setting: "Before Start - Below Line" },
      ],
    },

    "page-break",

    {
      title: "Engine Start",
      roles: ["engineStart"],
      content: [
        { item: "Engine Start Selector", setting: "IGN/Start" },
        { item: "ENG 1 Master Switch", setting: "On" },
        { item: "ENG 1 Parameters", setting: "Monitor" },
        { item: "ENG 2 Master Switch", setting: "On" },
        { item: "ENG 2 Parameters", setting: "Monitor" },
      ],
    },
    {
      title: "After Start",
      roles: ["afterEngineStart", "beforeTaxi"],
      content: [
        { item: "Parking Brake", setting: "Set" },
        { item: "Engine Start Selector", setting: "Norm" },
        { item: "APU Bleed", setting: "Off" },
        { item: "Engine Anti-Ice", setting: "As Req" },
        { item: "APU Master", setting: "Off" },
        { item: "Pitch Trim", setting: "Check Set" },
        { item: "Ground Spoilers", setting: "Arm" },
        { item: "Flaps", setting: "Set" },
        { item: "Rudder Trim", setting: "Check Zero" },
        { item: "Flight Controls", setting: "Check" },
        { item: "MFD Checklist", setting: "After Start" },
      ],
    },
    {
      title: "Taxi Out",
      roles: ["taxi"],
      content: [
        { item: "Nose Lights", setting: "Taxi" },
        { item: "Parking Brake", setting: "Release" },
        { item: "Brake Fans", setting: "As Req" },
      ],
    },
    {
      title: "Before Takeoff",
      roles: ["beforeTakeoff", "takeoff"],
      content: [
        { header: "Holding Short" },
        { item: "Engine & Wing Anti-Ice", setting: "As Req" },
        { item: "Cabin Crew", setting: "Advised" },
        { item: "Flight Director", setting: "Check On" },
        { item: "Autobrake", setting: "Armed" },
        { item: "Engine Start Selector", setting: "As Req / Norm" },
        { item: "Ground Spoilers", setting: "Check Armed" },
        { item: "Flaps", setting: "Check Set" },
        { item: "Takeoff Config Test", setting: "Check" },
        { item: "FMA", setting: "BRK RTO | CLB | NAV" },
        { item: "Brake Fans", setting: "As Req" },
        { item: "TCAS", setting: "TA/RA" },
        { item: "MFD Checklist", setting: "Before T/O - To the Line" },
        { header: "Before Entering the Runway" },
        { item: "Packs", setting: "As Req / On" },
        { item: "Strobes", setting: "On" },
        { item: "Landing Lights", setting: "On" },
        { item: "Nose Lights", setting: "Takeoff" },
        { item: "MFD Checklist", setting: "Before T/O - Below the Line" },
      ],
    },
    {
      title: "Climb",
      roles: ["climbOut"],
      content: [
        { item: "Landing Gear", setting: "Up" },
        { item: "Ground Spoilers", setting: "Disarm" },
        { item: "Flaps", setting: "Retracted" },
        { item: "Engine Start Selector", setting: "As Req" },
        { item: "Packs", setting: "On" },
        { item: "Engine & Wing Anti-Ice", setting: "As Req" },
        { item: "Nose Lights", setting: "Off" },
        { item: "MFD Checklist", setting: "After Takeoff" },
        { header: "At Transition Altitude" },
        { item: "Altimeter", setting: "Set STD" },
        { header: "At 10,000 ft" },
        { item: "Landing Lights", setting: "Off" },
        { item: "Passenger Signs", setting: "As Desired" },
        { item: "FMS PERF Page", setting: "Check" },
        { item: "FMS F-PLN Page", setting: "Monitor" },
      ],
    },
    {
      title: "Cruise",
      roles: ["cruise"],
      content: [
        { item: "Engine & Wing Anti-Ice", setting: "As Req" },
        { item: "Passenger Signs", setting: "As Desired" },
        { item: "ECAM Fuel / Pressurization", setting: "Monitor" },
        { item: "EFOB at Destination", setting: "Monitor" },
        { item: "Step Climbs", setting: "As Req" },
        { item: "FMS CRZ Flight Level", setting: "Adjust As Req" },
        { item: "Top of Descent (TOD)", setting: "Cross Check" },
      ],
    },
    {
      title: "Descent Preparation",
      roles: ["beforeDescent"],
      content: [
        { item: "FMS Approach & STAR", setting: "Check / Insert" },
        { item: "FMS Approach Performance", setting: "Check / Insert" },
        { item: "OIS Landing Perf", setting: "As Req" },
        { item: "BTV", setting: "As Desired" },
        { item: "Auto Brake", setting: "Arm" },
        { item: "Passenger Signs", setting: "As Req" },
      ],
    },

    "page-break",

    {
      title: "Descent",
      roles: ["descent"],
      content: [
        { item: "Speed Brakes", setting: "As Required" },
        { item: "Passenger Signs", setting: "As Desired" },
        { item: "Engine & Wing Anti-Ice", setting: "As Req" },
        { item: "Engine Start Selector", setting: "As Req" },
        { header: "At Transition Flight Level" },
        { item: "Altimeter", setting: "Set Local QNH" },
        { header: "At 10,000 ft" },
        { item: "Landing Lights", setting: "On" },
        { item: "Passenger Signs", setting: "On" },
        { item: "Cabin Crew", setting: "Advised" },
      ],
    },
    {
      title: "Approach",
      roles: ["approach", "landing"],
      content: [
        { item: "Nose Lights", setting: "Takeoff" },
        { item: "Engine Start Selector", setting: "As Req / Norm" },
        { item: "Engine & Wing Anti-Ice", setting: "As Req" },
        { item: "Autobrake", setting: "As Required" },
        { item: "Minimums", setting: "Set" },
        { item: "Cabin Crew", setting: "Advised" },
        { item: "MFD Checklist", setting: "Approach" },
        { header: "At Glide Slope Intercept" },
        { item: "Gear", setting: "Down" },
        { item: "Ground Spoilers", setting: "Arm" },
        { item: "Flaps", setting: "Full" },
      ],
    },
    {
      title: "After Landing",
      roles: ["afterLanding"],
      content: [
        { item: "Strobe Lights", setting: "Auto" },
        { item: "Landing Lights", setting: "Off" },
        { item: "Nose Lights", setting: "Taxi" },
        { item: "Engine & Wing Anti-Ice", setting: "As Req" },
        { item: "APU", setting: "As Req / Start" },
        { item: "Flaps", setting: "Up" },
        { item: "Ground Spoilers", setting: "Disarm" },
        { item: "EFIS LS Mode", setting: "Off" },
        { item: "EFIS WX / TERR / TRAF", setting: "Off" },
        { item: "TCAS", setting: "Stby" },
        { item: "Brake Temperature", setting: "Check" },
        { item: "Brake Fans", setting: "As Req" },
        { item: "MFD Checklist", setting: "After Landing" },
      ],
    },
    {
      title: "Parking / Shutdown",
      roles: ["parking", "shutdown"],
      content: [
        { item: "Parking Brake", setting: "Set" },
        { item: "Nose Lights", setting: "Off" },
        { item: "Engine & Wing Anti-Ice", setting: "As Req" },
        { item: "APU Bleed", setting: "On" },
        { item: "Engine Start Selector", setting: "Norm" },
        { header: "At Least 5 Minutes After Landing" },
        { item: "ENG 1 + 2 Master Switches", setting: "Off" },
        { item: "Passenger Signs", setting: "Off" },
        { item: "Beacon", setting: "Off" },
        { item: "Fuel Pumps", setting: "Off" },
        { item: "Brake Fans", setting: "As Req" },
        { item: "Transponder", setting: "Stby" },
        { item: "MFD Checklist", setting: "Parking" },
      ],
    },
    {
      title: "Securing the Aircraft",
      roles: ["securing"],
      content: [
        { item: "Parking Brake", setting: "As Req" },
        { item: "Oxygen Crew Supply", setting: "Off" },
        { item: "ADIRS", setting: "Off" },
        { item: "APU Bleed", setting: "Off" },
        { item: "External Power", setting: "As Req" },
        { item: "APU Master Switch", setting: "As Req" },
        { item: "Exterior Lights", setting: "Off" },
        { item: "Emergency Exit Lights", setting: "Off" },
        { item: "Passenger Signs", setting: "Off" },
        { item: "MFD Checklist", setting: "Securing the Aircraft" },
        { item: "Batteries", setting: "Off" },
      ],
    },
  ],
};
